import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import CheckboxText from "../../components/CheckboxText";
import { getCompletedStep, setCompletedStep } from "../../utils/localstorage";
const AiLabStep5 = () => {
  const history = useHistory();
  let { labId, labStep } = useParams<any>();
  const step = parseInt(labStep);
  const maxPart = 2;
  const [part, setPart] = useState(0);

  function nextPart(nextPart: number) {
    //Handel next Part
    if (nextPart > part) {
      setPart(nextPart);
      if (nextPart === maxPart) {
        setCompletedStep(labId, labStep);
      }
    }
  }
  useEffect(() => {
    //Set boxes checked if step all ready done.
    if (getCompletedStep(labId) >= labStep) {
      setPart(maxPart);
    }
  }, []);
  return (
    <div className="w-full h-full" style={{ maxWidth: 640 }}>
      <h1 className="heading-1">Frågor</h1>
      <div className="p">
        <CheckboxText
          text={
            <>
              <span className="abbr">AI</span>&#58;n ser direkt mönster. Lyckas man börja rita det mest karaktäristiska
              gissar den snabbt rätt. Lyckades du få <span className="abbr">AI</span>&#58;n att gissa rätt på bara några
              sekunder?
            </>
          }
          defultChecked={part > 0}
          nextPart={() => {
            nextPart(1);
          }}
        />
        <br />
        {/* Part 1 */}
        {part >= 1 && (
          <CheckboxText
            text={
              <div>
                Den här <span className="abbr">AI</span>&#58;n kan inte bokstäver och siffror. Däremot försöker den se
                vilket föremål dina bokstäver liknar. Tycker du att dina bokstäver och siffror liknade det som{" "}
                <span className="abbr">AI</span>&#58;n försökte gissa?
              </div>
            }
            defultChecked={part > 1}
            nextPart={() => {
              nextPart(2);
            }}
          />
        )}
        <br />
      </div>
      {/* Part 2 */}
      {part >= maxPart && (
        <p>
          <span
            className="tag text-white cursor-pointer"
            onClick={() => {
              history.push(`/${labId}/${step + 1}`);
            }}>
            fortsätt
          </span>
        </p>
      )}
      <div className="w-full h-24"></div>
    </div>
  );
};
export default AiLabStep5;
